import { Payload } from "@neworbit/redux-helpers";
import { Action } from "redux";
import { isRequestActive, loadAndTrack } from "redux-request-loading";
import { ThunkAction, ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../applicationState";
import { loadCustomerDetail } from "../customer/actions";

import * as actions from "./actionTypes";
import { CustomerTeamCreateUpdateModel, CustomerTeamListModel } from "./model";
import { CustomerTeamApi } from "./customerTeamApi";

export type CustomerTeamAction =
    ({ type: typeof actions.LOAD_CUSTOMER_TEAMS_SUCCESS } & Payload<{ customerId: string; teams: CustomerTeamListModel[] }>) |
    ({ type: typeof actions.CREATE_CUSTOMER_TEAM_SUCCESS } & Payload<{ customerId: string; team: CustomerTeamListModel }>) |
    ({ type: typeof actions.UPDATE_CUSTOMER_TEAM_SUCCESS } & Payload<{ customerId: string; teamId: string; team: CustomerTeamListModel }>);

export const loadCustomerTeamsSuccess = (customerId: string, teams: CustomerTeamListModel[]): CustomerTeamAction => ({
    payload: {
        customerId,
        teams,
    },
    type: actions.LOAD_CUSTOMER_TEAMS_SUCCESS
});

export const createCustomerTeamSuccess = (customerId: string, team: CustomerTeamListModel): CustomerTeamAction => ({
    payload: {
        customerId,
        team,
    },
    type: actions.CREATE_CUSTOMER_TEAM_SUCCESS
});

export const updateCustomerTeamSuccess = (customerId: string, teamId: string, team: CustomerTeamListModel): CustomerTeamAction => ({
    payload: {
        customerId,
        teamId,
        team,
    },
    type: actions.UPDATE_CUSTOMER_TEAM_SUCCESS
});

export function loadCustomerTeams(customerId: string, abortController: AbortController): ThunkAction<Promise<any>, ApplicationState, never, Action> {
    const requestName = `${actions.LOAD_CUSTOMER_TEAMS}_${customerId}`;
    return async (dispatch: ThunkDispatch<ApplicationState, never, Action>, getState: () => ApplicationState) => {
        const state = getState();
        if (isRequestActive(state, requestName) !== true) {
            const customer = state.customers.find(c => c.id === customerId);
            if (customer === undefined) {
                await dispatch(loadCustomerDetail({ customerId }));
            }

            const result = await loadAndTrack(dispatch, requestName, CustomerTeamApi.getAll(customerId, abortController));
            dispatch(loadCustomerTeamsSuccess(customerId, result));
        }
    };
}

export const createCustomerTeam = (customerId: string, customerTeam: CustomerTeamCreateUpdateModel) => {
    return async (dispatch: ThunkDispatch<ApplicationState, never, Action>) => {
        const result = await loadAndTrack(dispatch, actions.CREATE_CUSTOMER_TEAM, CustomerTeamApi.create(customerId, customerTeam));
        dispatch(createCustomerTeamSuccess(customerId, result));
    };
};

export const updateCustomerTeam = (customerId: string, teamId: string, customerTeam: CustomerTeamCreateUpdateModel) => {
    return async (dispatch: ThunkDispatch<ApplicationState, never, Action>) => {
        const result = await loadAndTrack(dispatch, `${actions.UPDATE_CUSTOMER_TEAM}_${teamId}`, CustomerTeamApi.update(customerId, teamId, customerTeam));
        dispatch(updateCustomerTeamSuccess(customerId, teamId, result));
    };
};
